import React from 'react';
import PropTypes from 'prop-types';

import './dropdown-list.scss';

const DropdownList = ({ items }) => {
  const dropdownClasses = items.length === 1 ? 'hidden' : '';

  return (
    <div className="dropdown-list-container">
      <ul>
        {items.map((item, index) => <li key={index}>{item}</li>)}
      </ul>
      <span className={`dropdown ${dropdownClasses}`}><span className="caret"></span></span>
    </div>
  );
};


DropdownList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.node).isRequired,
};


export default DropdownList;



// WEBPACK FOOTER //
// ./src/components/shared/dropdown-list/dropdown-list.js